export default {"src":"/_next/static/media/mail.734eac9c.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};